import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export const PLATFORM_URL_PARAMETER = 'platform';
export const DELIMITER: string = ', ';
export const DELIMITER_V2: string = ',';

// this platforms should be first in the list of platforms 
export const PLATFORMS_ORDER = [PLATFORM_TYPES.PC, PLATFORM_TYPES.EPIC];
